import type { Modifier, ClientRect } from '@dnd-kit/core'
import type { Transform } from '@dnd-kit/utilities'

export function restrictVerticallyToBoundingRect(
  transform: Transform,
  rect: ClientRect,
  boundingRect: ClientRect,
): Transform {
  const value = {
    ...transform,
  }

  if (rect.top + transform.y <= boundingRect.top) {
    value.y = boundingRect.top - rect.top
  } else if (
    rect.bottom + transform.y >=
    boundingRect.top + boundingRect.height
  ) {
    value.y = boundingRect.top + boundingRect.height - rect.bottom
  }

  return value
}

// The date containers have a negative margin at the bottom to help get the required layout.
// This function adjusts the rect to subtract the negative margin from the height.
function rectAdjustedForNegativeBottomMargin(element: Element): DOMRect {
  const rect = element.getBoundingClientRect()
  const style = getComputedStyle(element)
  const marginBottom = style.marginBottom ? parseInt(style.marginBottom, 10) : 0

  return new DOMRect(
    rect.left,
    rect.top,
    rect.width,
    rect.height + (marginBottom < 0 ? marginBottom : 0),
  )
}

export const restrictToItineraryDate: Modifier = ({
  draggingNodeRect,
  transform,
  active,
}) => {
  const lockedToDate = active?.data?.current?.lockedToDate
  if (!lockedToDate) {
    return transform
  }

  // Get rect of date container
  const dateContainer = document.querySelector(
    `[data-itinerarydate="${lockedToDate}"]`,
  )

  if (!draggingNodeRect || !dateContainer) {
    return transform
  }

  return restrictVerticallyToBoundingRect(
    transform,
    draggingNodeRect,
    rectAdjustedForNegativeBottomMargin(dateContainer),
  )
}
